exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.group-form-card[data-v-febddc72] { border: 1px dashed #d9d9d9; border-radius: 4px; padding: 12px 16px 0; margin-bottom: 16px; background: #fafafa;\n}\n.group-form-title[data-v-febddc72] { font-weight: bold; margin-bottom: 8px;\n}\n.group-card[data-v-febddc72] { border: 1px solid #e8e8e8; border-radius: 4px; padding: 12px 16px; margin-bottom: 16px;\n}\n.group-header[data-v-febddc72] { margin-bottom: 8px;\n}\n.group-name[data-v-febddc72] { font-weight: bold; margin-right: 8px;\n}\n.group-sort[data-v-febddc72] { color: #999; margin-left: 8px; font-size: 12px;\n}\n.group-ops[data-v-febddc72] { float: right;\n}\n", ""]);

// exports
